import script from "./BeitragsEntwicklung.vue?vue&type=script&setup=true&lang=js"
export * from "./BeitragsEntwicklung.vue?vue&type=script&setup=true&lang=js"

import "./BeitragsEntwicklung.vue?vue&type=style&index=0&id=26d5d740&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26d5d740"]])

export default __exports__